import './App.css';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

//移动端
import MHomepage from './mobile-pages/homepage/Homepage';
import MPrivacyPolicy from './mobile-pages/privacy-policy/PrivacyPolicy';
import useLanguageContext, { LanguageContext } from './context/useLanguageContext';
import useBgmContext, { BgmContext, BmgPlayer } from './context/useBgmContext';

function App() {

  const languageContext = useLanguageContext()
  const bgmContext = useBgmContext()
  const router = createBrowserRouter([

    {
      path: "/",
      element: <MHomepage />,
    },

    {
      path: "/privacyPolicy",
      element: <MPrivacyPolicy />,
    },
  ]);

  

  return (
    <BgmContext.Provider value={{...bgmContext}}>
      <BmgPlayer/>
      <LanguageContext.Provider value={{...languageContext}}>
        <RouterProvider router={router} />
      </LanguageContext.Provider>
    </BgmContext.Provider>
  );
}

export default App;
